import {Link} from 'external/react'
import Icon from 'external/font-awesome'
import {
   AppBar
  ,ToolBar
  ,Box
} from 'external/material'

import {styled}  from 'external/material'
import DrawerButton from 'components/Menu/Drawer'
import ProjectName from 'components/TopBar/ProjectName'
import PageLanguage from 'components/TopBar/PageLanguage'
import PageName from 'components/TopBar/PageName'
import UserName from 'components/TopBar/UserName'
import Logout from 'components/TopBar/Logout'

import useSession from 'hooks/session'
import useTranslations from 'hooks/translations'
import { centerVertically, flexGrow } from 'utils/style'
import { viewerGuard } from 'utils/url'

import Notification from './Notification'
import useProfile from 'hooks/profile'
import { environment } from '../../settings'
import FullScreenButton from 'components/FullScreenButton'

const StyledAppBar = styled(AppBar)(appBarStyles)

export default function TopBar() {
  const {navigation} = useSession()
  const profile = useProfile()
  const {language: languageId = 'es'} = useTranslations()

  return (
  <StyledAppBar component="nav" position="fixed">
    <ToolBar disableGutters variant="dense">
      <Box>
        {!profile.locked && <DrawerButton />}
        <ProjectName className="project-name" />
        <PageLanguage className="select-language" />
        {(false && (profile.domainName == 'testing-gen' || environment == 'development')) && (<FullScreenButton />)}
        <Logout className="logout-button" />
        <a {...viewerGuard({href:"https://edusystem.com/uso-y-manejo-estudiantes/", target:"_blank"})} className="help">
          <Icon name="faQuestionCircle" />
         </a>
      </Box>
    </ToolBar>
    <ToolBar disableGutters variant="dense">
      <Box>
        <PageName className="page-name" />
        <Box sx={flexGrow()} />
        <UserName className="username" />
      </Box>
    </ToolBar>
    <Notification />
  </StyledAppBar>)
}


function appBarStyles({theme}) {

  const toolbarComponent = {
    ...centerVertically,
    padding: '5px 15px',
    [theme.breakpoints.down('desktop')]: {
      padding: '4px 8px'
    }
  }

  return {
    display: 'flex',
    zIndex: theme.zIndex.drawer + 1,
    "& a.help": {
      ...centerVertically,
      color: '#69738e',
      cursor: 'pointer',
      marginRight: 10,
      fontSize: '1.8em',
      '&:hover': {
        transform: 'scale(1.04)'
      }
    },
    "& .MuiToolbar-root": {
      display: 'flex',
       "&:first-of-type": {
          backgroundColor: theme.palette.background.paper
       },
      ...theme.mixins.toolbar,
     "& > .MuiBox-root": {
       display: 'flex',
       flexGrow: 1,
       "& > .project-name": {
          flexGrow: 1,
          ...toolbarComponent
       },
       "& > .select-language": { ...centerVertically },
       "& > .logout-button": {
        ...toolbarComponent,
        paddingLeft: 0
        },
        "& > .page-name": {
          paddingLeft: 30,
          [theme.breakpoints.down('desktop')]: {
            paddingLeft: 27
          }
        },
        "& > .username": {
          paddingRight: 31,
          [theme.breakpoints.down('desktop')]: {
            paddingRight: 20
          }
        },

      }
    }
  }
}
